export default __webpack_public_path__ + "static/media/spa-image-14.0657141c.jpg";